import React, { Component } from 'react';

class Title extends Component {
  render() {
    return (
      <div className="page-title" {...this.props}>
        {this.props.children}
      </div>
    );
  }
}

export default Title;



// WEBPACK FOOTER //
// ./src/components/Page/Title/index.js